import React from 'react';
import { useT } from '@/lib/i18n';
import { LegalLayout } from '@/components/legal/LegalLayout';

const Cookies = () => {
  const { lang } = useT();
  const fr = (
    <>
      <h2>Qu&apos;est-ce qu&apos;un cookie ?</h2>
      <p>Un cookie est un petit fichier texte stocké dans votre navigateur par les sites que vous visitez. Il permet à un site de mémoriser certaines informations sur votre visite.</p>

      <h2>Cookies utilisés par HighlightAI</h2>

      <h2>1. Cookies strictement nécessaires</h2>
      <p>Ces cookies sont indispensables au fonctionnement du service et ne peuvent pas être désactivés :</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>highlightai_access</strong> (cookie httpOnly + Secure + SameSite=Lax) — Jeton de session JWT d&apos;authentification, durée 30 jours. Inaccessible au JavaScript pour protéger contre les attaques XSS.</li>
        <li><strong>highlightai_csrf</strong> (cookie Secure + SameSite=Lax) — Jeton anti-CSRF (double-submit), envoyé en miroir dans l&apos;en-tête <code>X-CSRF-Token</code> sur les requêtes mutables.</li>
        <li><strong>highlightai_lang</strong> (localStorage) — Préférence de langue FR/EN</li>
      </ul>

      <h2>2. Cookies tiers</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Stripe</strong> — Cookies de sécurité pour le checkout (3D Secure, anti-fraude). Voir <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer">politique cookies Stripe</a></li>
      </ul>

      <h2>3. Cookies analytiques</h2>
      <p>Actuellement, HighlightAI n&apos;utilise <strong>aucun outil d&apos;analyse tiers</strong> (pas de Google Analytics, Hotjar, Mixpanel, etc.). Aucun cookie de tracking publicitaire n&apos;est déposé.</p>

      <h2>Gestion des cookies</h2>
      <p>Vous pouvez à tout moment supprimer les données stockées par HighlightAI dans votre navigateur via les paramètres :</p>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Chrome</strong> : Paramètres → Confidentialité → Effacer les données de navigation</li>
        <li><strong>Firefox</strong> : Préférences → Vie privée et sécurité → Cookies</li>
        <li><strong>Safari</strong> : Préférences → Confidentialité → Gérer les données</li>
      </ul>
      <p>Note : la suppression du token JWT vous déconnectera automatiquement du service.</p>

      <h2>Stockage des cookies YouTube (Pro)</h2>
      <p>Les utilisateurs Pro peuvent uploader leur fichier <code>cookies.txt</code> YouTube pour permettre l&apos;import depuis YouTube. Ces cookies sont stockés <strong>côté serveur uniquement</strong>, chiffrés base64 dans votre profil, et utilisés exclusivement pour télécharger les vidéos que vous demandez. Ils ne sont jamais partagés et peuvent être supprimés à tout moment depuis vos paramètres.</p>
    </>
  );
  const en = (
    <>
      <h2>What is a cookie?</h2>
      <p>A cookie is a small text file stored by websites in your browser to remember information about your visit.</p>
      <h2>Cookies used by HighlightAI</h2>
      <h2>1. Strictly necessary</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>highlightai_access</strong> (httpOnly + Secure + SameSite=Lax cookie) — JWT session token, 30-day expiry. JS-inaccessible to prevent XSS theft.</li>
        <li><strong>highlightai_csrf</strong> (Secure + SameSite=Lax cookie) — Anti-CSRF token (double-submit), mirrored in <code>X-CSRF-Token</code> header on mutating requests.</li>
        <li><strong>highlightai_lang</strong> (localStorage) — FR/EN language preference</li>
      </ul>
      <h2>2. Third-party</h2>
      <ul className="list-disc list-inside space-y-1 ml-2">
        <li><strong>Stripe</strong> — Security cookies during checkout (3D Secure, anti-fraud). See <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer">Stripe cookies policy</a></li>
      </ul>
      <h2>3. Analytics</h2>
      <p>HighlightAI uses <strong>no third-party analytics</strong> (no Google Analytics, Hotjar, Mixpanel, etc.). No advertising tracking cookies.</p>
      <h2>Managing cookies</h2>
      <p>You can delete cookies anytime from your browser settings (Chrome/Firefox/Safari → Privacy → Clear data). Deleting the JWT token will log you out.</p>
      <h2>YouTube cookies storage (Pro)</h2>
      <p>Pro users can upload their YouTube <code>cookies.txt</code> to enable YouTube imports. These are stored <strong>server-side only</strong>, base64-encoded in your profile, used exclusively to download the videos you request. Never shared, removable anytime from settings.</p>
    </>
  );
  return <LegalLayout titleFr="Politique de cookies" titleEn="Cookie Policy">{lang === 'fr' ? fr : en}</LegalLayout>;
};

export default Cookies;
